import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { getCurrentParkingPlace } from 'src/store/parking/selectors';

export const ParkingBookingSidesheetTitle: FC = () => {
  const parking = useSelector(getCurrentParkingPlace);

  const title = useMemo((): string => {
    return parking?.title
      ? `Парковочное место ${parking.title}`
      : 'Объект бронирования';
  }, [parking?.title]);

  return parking ? (
    <Typography ellipsis variant='h5' data-testid='bookingSideSheetTitle'>
      {title}
    </Typography>
  ) : null;
};
